import { startsWith } from 'lodash';

export const formatPhone = (phone: string, countryCode = '84') => {
  if (startsWith(phone, '0')) return `${countryCode}-${phone.substring(1)}`;
  return `${countryCode}-${phone}`;
};
